import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const AyetStudios = ({})=> {

  const currentUser = security.currentUserValue;
  const apiKey    = 10607;

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        src={`https://www.ayetstudios.com/offers/web_offerwall/${apiKey}?external_identifier=${currentUser.id}`}
      ></iframe>


    </Fragment>
  );
};

export default AyetStudios;
